import { useEffect, useState } from "react";

const BREAKPOINT = 800;

export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState<boolean | null>(null);

  useEffect(() => {
    if (!window) return;

    setIsDesktop(window.innerWidth > BREAKPOINT)

    const listener = () => {
      setIsDesktop(window.innerWidth > BREAKPOINT);
    };

    window.addEventListener("resize", listener);

    return () => {
      if (!window) return;
      window.removeEventListener("resize", listener);
    };
  }, []);

  return isDesktop;
};
